import type { FeatureEvents, ScreenEvent, TrackEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject, TrackAction, TrackActionSubject } from '../new-analytics-types';

export enum AppContainersScreens {
  appContainersActionsScreen = 'appContainersActionsScreen',
  appContainersSyncErrorsScreen = 'appContainersSyncErrorsScreen',
  appContainersInstallAppContainerDrawerScreen = 'appContainersInstallAppContainerDrawerScreen',
  userConnectedAppsListScreen = 'singleAppListingUserConnectedAppsScreen',
}

const screen = {
  appContainersActionsScreen: (): ScreenEvent => ({
    data: {
      name: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92804',
  }),
  appContainersSyncErrorsScreen: (): ScreenEvent => ({
    data: {
      name: AppContainersScreens.appContainersSyncErrorsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/94004',
  }),
  installAppContainerDrawerScreen: (): ScreenEvent => ({
    data: {
      name: AppContainersScreens.appContainersInstallAppContainerDrawerScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93063',
  }),
};

const ui = {
  appActionsAllActionsCheck: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'appContainersAllActionsCheck',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92805',
  }),
  appActionsAllActionsUncheck: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'appContainersAllActionsUncheck',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92807',
  }),
  appActionsActionCheck: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'appContainersActionCheck',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92808',
  }),
  appActionsActionUncheck: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'appContainersActionUncheck',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/92809',
  }),
  viewAppDetailsClicked: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Link,
      actionSubjectId: 'appContainersViewAppDetailsClicked',
      source: AppContainersScreens.userConnectedAppsListScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93536',
  }),
  closeInstallAppContainerDrawer: (): UIEvent => ({
    data: {
      action: Action.Closed,
      actionSubject: ActionSubject.Modal,
      actionSubjectId: 'appContainersCloseInstallDrawer',
      source: AppContainersScreens.userConnectedAppsListScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93274',
  }),
  openInstallAppContainerDrawer: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'appContainersOpenInstallDrawer',
      source: AppContainersScreens.userConnectedAppsListScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93273',
  }),
};

const track = {
  appContainersListCapabilityContainersErrored: (): TrackEvent => ({
    data: {
      action: TrackAction.Errored,
      actionSubject: TrackActionSubject.TWGAppContainer,
      actionSubjectId: 'appContainersListCapabilityContainersErrored',
      source: AppContainersScreens.appContainersInstallAppContainerDrawerScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93071',
  }),
  appContainersInstallAppContainerErrored: (): TrackEvent => ({
    data: {
      action: TrackAction.Errored,
      actionSubject: TrackActionSubject.TWGAppContainer,
      actionSubjectId: 'appContainersInstallAppContainerErrored',
      source: AppContainersScreens.appContainersInstallAppContainerDrawerScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93071',
  }),
  appContainersActionsConfigurationMutation: (): TrackEvent => ({
    data: {
      action: TrackAction.Changed,
      actionSubject: TrackActionSubject.TWGActionsConfiguration,
      actionSubjectId: 'appContainersActionsConfigurationChanged',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93465',
  }),
  appContainersActionsConfigurationMutationErrored: (): TrackEvent => ({
    data: {
      action: TrackAction.Errored,
      actionSubject: TrackActionSubject.TWGActionsConfiguration,
      actionSubjectId: 'appContainersActionsConfigurationErrored',
      source: AppContainersScreens.appContainersActionsScreen,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93466',
  }),
};

export const appContainerEvents: FeatureEvents<keyof typeof screen, keyof typeof ui, keyof typeof track, string> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/TEAMGRAPH/pages/6109683189/Action+permissions+-+Analytics+spec',
  screen,
  ui,
  track,
  operational: {},
};
